import { render, staticRenderFns } from "./customerOfInsurance.vue?vue&type=template&id=c529fb60&scoped=true&"
import script from "./customerOfInsurance.vue?vue&type=script&lang=js&"
export * from "./customerOfInsurance.vue?vue&type=script&lang=js&"
import style0 from "./customerOfInsurance.vue?vue&type=style&index=0&id=c529fb60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c529fb60",
  null
  
)

export default component.exports